module.exports = __webpack_public_path__ + "assets/img/join3.912eef1a.png";